import { render, staticRenderFns } from "./m_AllSuppliers.vue?vue&type=template&id=5c155088&scoped=true&"
import script from "./m_AllSuppliers.vue?vue&type=script&lang=js&"
export * from "./m_AllSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./m_AllSuppliers.vue?vue&type=style&index=0&id=5c155088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c155088",
  null
  
)

export default component.exports